/**
 * Legacy initialization - now handled by ApoAlgoliaTracking system
 */
export const initTracking = () => {}

/**
 * AdSpirit click event tracking - separate from Algolia tracking
 */
export const trackAdSpiritClickEvent = (clickUrl: string): void => {
  fetch(clickUrl, {
    method: "GET",
    mode: "no-cors",
    credentials: "omit",
    referrerPolicy: "no-referrer"
  })
    .catch((err) => console.warn("AdSpirit tracking failed", err));
}
